import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";
import { useExpenseStore } from "../store";

export const schedulePaymentRequisition = ({
  churchId,
  requisitionData,
  requisitionId
}) => {
  return axios.patch(
    `/churches/${churchId}/requisitions/${requisitionId}/schedule-payment`,
    requisitionData
  );
};

export const useSchedulePaymentRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeRequisitionFlowModal =
    useExpenseStore.getState().closeRequisitionFlowModal;
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);
      queryClient.invalidateQueries(["requisition"]);

      setNotification({
        type: "success",
        message: "Requisition payment scheduled successfully!"
      });

      closeRequisitionFlowModal();

      navigate("/finances/temp/expense/requisition");
    },
    ...config,
    mutationFn: schedulePaymentRequisition
  });
};
